var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 41,
    viewBox: "0 0 11 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.05425 26.392L0.31825 0.799997H10.7343L8.99825 26.392H2.05425ZM5.52625 40.448C3.95825 40.448 2.67025 39.944 1.66225 38.936C0.65425 37.928 0.15025 36.7333 0.15025 35.352C0.15025 33.9333 0.65425 32.7573 1.66225 31.824C2.67025 30.8533 3.95825 30.368 5.52625 30.368C7.13158 30.368 8.41958 30.8533 9.39025 31.824C10.3983 32.7573 10.9023 33.9333 10.9023 35.352C10.9023 36.7333 10.3983 37.928 9.39025 38.936C8.41958 39.944 7.13158 40.448 5.52625 40.448Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorSign);
export default __webpack_public_path__ + "static/media/error_sign.cc28c1a4e333908ce998ccc7bf2ef561.svg";
export { ForwardRef as ReactComponent };